import { BubbleHelpFilled, Clear } from '@ori-ui/icons';
import type { Theme } from '@ori-ui/mui';
import { styled } from '@ori-ui/mui';

interface GetIconStylesProps {
  theme: Theme;
}

const getIconStyles = ({ theme }: GetIconStylesProps) => ({
  display: 'flex',
  height: '32px',
  padding: theme.spacing(0, 2.8, 0, 2),
  width: '32px',
});

export const OpenIcon = styled(BubbleHelpFilled)(getIconStyles);

export const CloseIcon = styled(Clear)(getIconStyles);
